<template>
    <div class="input-group xigua-input-number custom-input-group-width"
         :class="[
        size ? 'input-' + size: '',
        {
        'disabled': disabled
        }
    ]"
    >
        <input type="number"
               class="form-control"
               v-model="currentValue"
               @keydown.up.native.prevent="increase"
               @keydown.down.native.prevent="decrease"
               @blur="handleBlur"
               :disabled="disabled"
               :class="size ? 'input-' + size: ''"
               :max="max"
               :min="min"
               :placeholder="placeholder"
        >
        <div class="input-group-addon custom-input-group-addon">
            <div :class="{'disabled': maxDisabled}"
                 v-repeat-click="increase"
            >
                <i class="icon-angle-up"></i>
            </div>
            <div :class="{'disabled': minDisabled}"
                 v-repeat-click="decrease"
            >
                <i class="icon-angle-down"></i>
            </div>

        </div>


    </div>


</template>
<style rel="stylesheet/css" lang="postcss">
    .custom-input-group-width {
        width: 100%;
        position: relative;
    }
    .custom-input-group-width input{

    }
    .custom-input-group-addon {
        position: absolute;
        z-index: 2;
        border: none !important;
        background: transparent !important;
        margin-top: 4px;
        padding-right: 25% !important;
        top: 0;
        right: 0;
    }
    @media (max-width: 768px) {
        .custom-input-group-addon {
            padding-right: 40%;
        }
    }
</style>
<script>
    const on = (() => {
        if (document.addEventListener) {
            return function (element, event, handler) {
                if (element && event && handler) {
                    element.addEventListener(event, handler, false)
                }
            }
        }
        return function (element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler)
            }
        }
    })()

    const off = (() => {
        if (document.removeEventListener) {
            return function (element, event, handler) {
                if (element && event) {
                    element.removeEventListener(event, handler, false)
                }
            }
        }
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler)
            }
        }
    })()

    const once = function (el, event, fn) {
        var listener = function () {
            if (fn) {
                fn.apply(this, arguments)
            }
            off(el, event, listener)
        }
        on(el, event, listener)
    }

    export default{
        name: 'custom-input-number',
        props: {
            step: {
                type: Number,
                default: 1
            },
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            },
            value: {
                default: 0
            },
            placeholder: {
                type: String,
                default: ''
            },
            disabled: Boolean,
            size: String,
            controls: {
                type: Boolean,
                default: true
            },
            // 保持初始化null
            initAsNull: {
                type: Boolean,
                default: false
            },
            // 只能输入整数
            isInt: {
                type: Boolean,
                default: false
            }
        },
        directives: {
            repeatClick: {
                bind (el, binding, vnode) {
                    let interval = null
                    let startTime
                    const handler = () => vnode.context[binding.expression].apply()
                    const clear = () => {
                        if (new Date() - startTime < 100) {
                            handler()
                        }
                        clearInterval(interval)
                        interval = null
                    }
                    on(el, 'mousedown', () => {
                        startTime = new Date()
                        once(document, 'mouseup', clear)
                        clearInterval(interval)
                        interval = setInterval(handler, 100)
                    })
                }
            }
        },
        data () {
            return {
                currentValue: 0,
                isInit: true,
            }
        },
        watch: {
            value: {
                immediate: true,
                handler (value) {
                    let newVal = Number(value)
                    if (isNaN(newVal)) return
                    newVal = this.isInt ? Math.round(newVal) : newVal
                    if (newVal >= this.max) newVal = this.max
                    if (newVal <= this.min) newVal = this.min
                    this.currentValue = value === null && this.initAsNull && this.isInit ? value : newVal
                    this.$emit('input', this.currentValue)
                }
            },
            max: {
                immediate: true,
                handler (value) {
                    const newVal = Number(value)
                    if (isNaN(value)) return
                    if (newVal <= this.currentValue) {
                        this.currentValue = newVal
                    }
                }
            },
            min: {
                immediate: true,
                handler (value) {
                    const newVal = Number(value)
                    if (isNaN(value)) return
                    if (newVal >= this.currentValue) {
                        this.currentValue = this.currentValue === null && this.initAsNull && this.isInit ? this.currentValue : newVal
                    }
                }
            },
            currentValue: {
                immediate: true,
                handler (value) {
                    // 解决小数点后不能输入0的问题: 只有一个.，并且0结尾的时候，不进行处理
                    if (value === '' || (typeof value === 'string' && /[0]+$/.test(value))
                        && value.indexOf('.') === value.lastIndexOf('.')
                        && value.indexOf('.') !== -1) return
                    const newVal = Number(value)
                    if (isNaN(newVal)) return
                    this.setCurrentValue(value === null && this.initAsNull && this.initAsNull ? value : newVal)
                }
            }
        },
        computed: {
            minDisabled () {
                return this._decrease(this.value, this.step) < this.min
            },
            maxDisabled () {
                return this._increase(this.value, this.step) > this.max
            },
            precision () {
                const { value, step, _getPrecision } = this
                return Math.max(_getPrecision(value), _getPrecision(step))
            }
        },
        methods: {
            // 按照精度 返回
            _toPrecision (num, _precision) {
                let precision = _precision
                if (typeof precision === 'undefined') precision = this.precision
                return parseFloat(parseFloat(Number(num).toFixed(precision)))
            },
            // 获取精度
            _getPrecision (value) {
                const valueString = value.toString()
                const dotPosition = valueString.indexOf('.')
                let precision = 0
                if (dotPosition !== -1) {
                    precision = valueString.length - dotPosition - 1
                }
                return precision
            },
            _increase (val, step) {
                if (typeof val !== 'number') return this.currentValue
                const precisionFactor = Math.pow(10, this.precision)
                return this._toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor)
            },
            _decrease (val, step) {
                if (typeof val !== 'number') return this.currentValue
                const precisionFactor = Math.pow(10, this.precision)
                return this._toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor)
            },

            increase () {
                if (this.disabled || this.maxDisabled) return
                const value = this.value || 0
                const newVal = this._increase(value, this.step)
                if (newVal > this.max) return
                this.setCurrentValue(newVal)
            },
            decrease () {
                if (this.disabled || this.minDisabled) return
                const value = this.value || 0
                const newVal = this._decrease(value, this.step)
                if (newVal < this.min) return
                this.setCurrentValue(newVal)
            },
            handleBlur () {
                this.setCurrentValue(this.currentValue)
            },
            setCurrentValue (_newVal) {
                if (this.isInit && this.currentValue === null && this.initAsNull) {
                    return;
                }
                // 不是初始化，
                const oldVal = this.currentValue
                let newVal = _newVal
                if (newVal >= this.max) newVal = this.max
                if (newVal <= this.min) newVal = this.min
                if (oldVal === newVal) return;
                this.currentValue = newVal
                this.$emit('change', newVal, oldVal)
                this.$emit('input', newVal)
                this.currentValue = newVal
                this.isInit = false;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// index.vue?23b6ef6a